var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"float":"right"},attrs:{"color":"primary","disabled":_vm.disableBtn()},on:{"click":_vm.enroll}},[_vm._v("Add")])
}
var staticRenderFns = []

export { render, staticRenderFns }